module.exports = __webpack_public_path__ + "media/images/admin/icons/coffee-63ddee6e256674317cbba9c230b43a45.svg";